import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { GetConstantListResponse, GetConstantListResponseItem } from "../../../models/response/constant/GetConstantListResponse";
import { ConstantService } from "../../../services/ConstantService";
import { ServiceService } from "../../../services/ServiceService";
import { AddServiceResponse } from "../../../models/response/service/AddServiceResponse";
import { GetServiceByIdResponse } from "../../../models/response/service/GetServiceByIdResponse";
import { AddServiceRequest } from "../../../models/request/service/AddServiceRequest";
import CustomMultiSelect, { CustomMultiSelectModel } from "../../../components/CustomMultiSelect";
import CustomSwitch from "../../../components/CustomSwitch";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { WithholdingService } from "../../../services/WithholdingService";

const ServiceAdd = () => {
    const auth = useSelector((state: RootState) => state.auth)
    const navigate = useNavigate();
    const pageName = "Ön Muhasebe > Tanımlamalar > Hizmet Kalemi Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [serviceId, setServiceId] = useState<string | undefined>(undefined);
    const [code, setCode] = useState<string | undefined>(undefined);
    const [name, setName] = useState<string | undefined>(undefined);
    const [accountingCode, setAccountingCode] = useState<string | undefined>(undefined);
    const [isIncome, setIsIncome] = useState(false);
    const [isOutcome, setIsOutcome] = useState(false);
    const [selectedOutcomePercentage, setSelectedOutcomePercentage] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedIncomePercentage, setSelectedIncomePercentage] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [transferDate, setTransferDate] = useState<string | undefined>(undefined);
    const [selectedDriverOutcome, setSelectedDriverOutcome] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedOutcomeTypes, setSelectedOutcomeTypes] = useState<CustomMultiSelectModel[]>([]);
    const [selectedIncomeTypes, setSelectedIncomeTypes] = useState<CustomMultiSelectModel[]>([]);
    const [selectedMultipliers, setSelectedMultipliers] = useState<CustomMultiSelectModel[]>([]);
    const [isCustomActive, setIsCustomActive] = useState(true);
    const [isAntrepoIn, setIsAntrepoIn] = useState(false);
    const [needQuantity, setNeedQuantity] = useState(false);
    const [isAntrepoOut, setIsAntrepoOut] = useState(false);
    const [defaultOption, setDefaultOption] = useState<GetConstantListResponseItem | undefined>(undefined);

    const [isWithholdingRate, setIsWithholdingRate] = useState(false);
    const [selectedWithholdingRate, setSelectedWithholdingRate] = useState<CustomSingleSelectModel | undefined>(undefined);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var response2: GetConstantListResponse = await ConstantService.getConstantList('SERVICE_INCOME_OUTCOME_PERCENTAGE', undefined, undefined)

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return;
            }

            setDefaultOption(response2.data.find(x => x.additionalValue1 == "0"));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetServiceByIdResponse = await ServiceService.getServiceById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setServiceId(response.data.serviceId);
                setCode(response.data.code);
                setName(response.data.name);
                setAccountingCode(response.data.accountingCode);

                setIsIncome(response.data.isIncome);

                if (response.data.incomePercentageId)
                    setSelectedIncomePercentage({ label: response.data.incomePercentageName, value: response.data.incomePercentageId });

                setIsOutcome(response.data.isOutcome);

                if (response.data.outcomePercentageId)
                    setSelectedOutcomePercentage({ label: response.data.outcomePercentageName, value: response.data.outcomePercentageId });

                setTransferDate(response.data.transferDate);
                setIsCustomActive(response.data.isCustomActive);
                setIsAntrepoIn(response.data.isAntrepoIn);
                setNeedQuantity(response.data.needQuantity);
                setIsAntrepoOut(response.data.isAntrepoOut);

                setSelectedOutcomeTypes(response.data.serviceOutcomeTypes);
                setSelectedMultipliers(response.data.serviceMultipliers);
                setSelectedIncomeTypes(response.data.serviceIncomeTypes);

                if (response.data.driverOutcomeId)
                    setSelectedDriverOutcome({ label: response.data.driverOutcomeName, value: response.data.driverOutcomeId });

                if (response.data.withholdingRateId && response.data.withholdingRateName) {
                    setIsWithholdingRate(true);
                    setSelectedWithholdingRate({ label: response.data.withholdingRateName, value: response.data.withholdingRateId })
                }
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveService = async () => {
        try {
            var isAntrepoModule = auth?.user?.user?.data?.authorizedMenus?.find(x => x.menuName.startsWith("Antrepo Modülü >")) ?? false;

            if (Helpers.isEmpty(name))
                toast.error('Ad alanını doldurunuz!')
            else if (isIncome && !selectedIncomePercentage)
                toast.error('Gelir % alanını doldurunuz!')
            else if (isOutcome && !selectedOutcomePercentage)
                toast.error('Gider % alanını doldurunuz!')
            else if (isAntrepoModule && !isAntrepoIn && !isAntrepoOut)
                toast.error('Antrepo Giriş veya Antrepo Çıkış alanını doldurunuz!')
            else if (isWithholdingRate && !selectedWithholdingRate)
                toast.error('Tevkifat Türü alanı zorunludur!')
            else {
                dispatch(storeActivityIndicator(true));

                var obj: AddServiceRequest = {
                    serviceId: serviceId,
                    code: code,
                    name: name,
                    accountingCode: accountingCode,
                    isIncome: isIncome ? 1 : 0,
                    incomePercentageId: selectedIncomePercentage?.value,
                    isOutcome: isOutcome ? 1 : 0,
                    outcomePercentageId: selectedOutcomePercentage?.value,
                    transferDate: transferDate,
                    isCustomActive: isCustomActive ? 1 : 0,
                    isAntrepoIn: isAntrepoIn ? 1 : 0,
                    needQuantity: needQuantity ? 1 : 0,
                    isAntrepoOut: isAntrepoOut ? 1 : 0,
                    driverOutcomeId: selectedDriverOutcome?.value,
                    serviceOutcomeTypes: selectedOutcomeTypes.map(function (x) {
                        return {
                            outcomeTypeId: x.value
                        }
                    }),
                    serviceIncomeTypes: selectedIncomeTypes.map(function (x) {
                        return {
                            incomeTypeId: x.value
                        }
                    }),
                    serviceMultipliers: selectedMultipliers.map(function (x) {
                        return {
                            multiplierId: x.value
                        }
                    }),
                    withholdingRateId: selectedWithholdingRate?.value
                }

                var response: AddServiceResponse = await ServiceService.addService(obj);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <KTCard className="ebbe-card">
                        <KTCardBody>
                            <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                            <div className='row'>
                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Kod</label>
                                        <input disabled style={{ border: '1px solid #F1F1F4' }} value={code} onChange={(e) => setCode(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Gelir %</label>

                                        <Box flexDirection="row">
                                            <Box mr="15px" justifyContent="center">
                                                <div className="form-check form-check-custom form-check-solid d-flex">
                                                    <input onChange={(e) => {
                                                        setIsIncome(!isIncome);
                                                        setIsOutcome(false);

                                                        setSelectedIncomePercentage(e.target.checked && defaultOption ? { label: defaultOption.value, value: defaultOption.constantId } : undefined);
                                                        setSelectedOutcomePercentage(undefined);
                                                    }} className="form-check-input" type="checkbox" value="" checked={isIncome} />
                                                </div>
                                            </Box>
                                            <Box flexGrow={1} justifyContent="center">
                                                <CustomSingleSelect
                                                    selectedValue={selectedIncomePercentage}
                                                    onChange={setSelectedIncomePercentage}
                                                    disabled={!isIncome}
                                                    onMenuOpen={() => ConstantService.getConstantList('SERVICE_INCOME_OUTCOME_PERCENTAGE')}
                                                    labelName='value'
                                                    valueName='constantId'
                                                />
                                            </Box>
                                        </Box>
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Tevkifat Uygulanır Mı?</label>

                                        <Box flexDirection='row'>
                                            <Box width='80px'>
                                                <CustomSwitch
                                                    isActive={isWithholdingRate}
                                                    setIsActive={() => {
                                                        var newVal = !isWithholdingRate;

                                                        if (!newVal)
                                                            setSelectedWithholdingRate(undefined);

                                                        setIsWithholdingRate(newVal);
                                                    }}
                                                />
                                            </Box>
                                            <Box ml='15px' flexGrow={1}>
                                                <CustomSingleSelect
                                                    disabled={!isWithholdingRate}
                                                    selectedValue={selectedWithholdingRate}
                                                    onChange={setSelectedWithholdingRate}
                                                    onMenuOpen={() => ConstantService.getConstantList('WITHHOLDING_RATE')}
                                                    labelName='value'
                                                    valueName='constantId'
                                                />

                                            </Box>
                                        </Box>
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Hizmet Kalemi Miktar</label>
                                        <CustomSwitch isActive={needQuantity} setIsActive={setNeedQuantity} />
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Ad</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Gider %</label>

                                        <Box flexDirection="row">
                                            <Box mr="15px" justifyContent="center">
                                                <div className="form-check form-check-custom form-check-solid d-flex">
                                                    <input onChange={(e) => {
                                                        setIsIncome(false);
                                                        setIsOutcome(!isOutcome);

                                                        setSelectedOutcomePercentage(e.target.checked && defaultOption ? { label: defaultOption.value, value: defaultOption.constantId } : undefined);
                                                        setSelectedIncomePercentage(undefined);
                                                    }} className="form-check-input" type="checkbox" value="" checked={isOutcome} />
                                                </div>
                                            </Box>
                                            <Box flexGrow={1} justifyContent="center">
                                                <CustomSingleSelect
                                                    selectedValue={selectedOutcomePercentage}
                                                    onChange={setSelectedOutcomePercentage}
                                                    disabled={!isOutcome}
                                                    onMenuOpen={() => ConstantService.getConstantList('SERVICE_INCOME_OUTCOME_PERCENTAGE')}
                                                    labelName='value'
                                                    valueName='constantId'
                                                />
                                            </Box>
                                        </Box>
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Antrepo Giriş</label>
                                        <CustomSwitch isActive={isAntrepoIn} setIsActive={setIsAntrepoIn} />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>
                                        <CustomSwitch isActive={isCustomActive} setIsActive={setIsCustomActive} />
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Muhasebe Kodu</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={accountingCode} onChange={(e) => setAccountingCode(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Aktarım Tarihi</label>

                                        <Box flexDirection="row">
                                            <Box flexGrow={1} justifyContent="center">
                                                <input disabled style={{ border: '1px solid #F1F1F4' }} value={transferDate} onChange={(e) => setTransferDate(e.target.value)} type="date" className="form-control form-control-solid" />
                                            </Box>

                                            {
                                                !Helpers.isEmpty(transferDate) && (
                                                    <Box ml="15px" justifyContent="center">
                                                        <i style={{ fontSize: 24 }} className='text-success fa fa-check-circle' />
                                                    </Box>
                                                )
                                            }
                                        </Box>
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Antrepo Çıkış</label>
                                        <CustomSwitch isActive={isAntrepoOut} setIsActive={setIsAntrepoOut} />
                                    </div>
                                </div>
                            </div>
                        </KTCardBody>
                    </KTCard>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <h4 className="mb-10 text-black">Gelir Türleri</h4>

                            <div className='row'>
                                <div className="col-md-6">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Gelir Türü</label>

                                    <CustomMultiSelect
                                        selectedValues={selectedIncomeTypes}
                                        onChange={setSelectedIncomeTypes}
                                        onMenuOpen={() => ConstantService.getConstantList('SERVICE_INCOME_TYPE')}
                                        labelName='value'
                                        valueName='constantId'
                                        additionalValue1Name="additionalValue1"
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Çarpan</label>

                                    <CustomMultiSelect
                                        selectedValues={selectedMultipliers}
                                        onChange={setSelectedMultipliers}
                                        onMenuOpen={() => ConstantService.getConstantList('MULTIPLIER_TYPE')}
                                        labelName='value'
                                        valueName='constantId'
                                        additionalValue1Name="additionalValue1"
                                    />
                                </div>
                            </div>
                        </KTCardBody>
                    </KTCard>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <h4 className="mb-10 text-black">Gider Türleri</h4>

                            <div className='row'>
                                <div className="col-md-6">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Gider Türü</label>

                                    <CustomMultiSelect
                                        selectedValues={selectedOutcomeTypes}
                                        onChange={(selectedObjs) => {
                                            if (!selectedObjs.map(x => x.additionalValue1).includes("1"))
                                                setSelectedDriverOutcome(undefined);

                                            setSelectedOutcomeTypes(selectedObjs);
                                        }}
                                        onMenuOpen={() => ConstantService.getConstantList('SERVICE_OUTCOME_TYPE')}
                                        labelName='value'
                                        valueName='constantId'
                                        additionalValue1Name="additionalValue1"
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Sürücü Gider Kalemleri</label>

                                    <CustomSingleSelect
                                        selectedValue={selectedDriverOutcome}
                                        onChange={setSelectedDriverOutcome}
                                        disabled={!selectedOutcomeTypes.map(x => x.additionalValue1).includes("1")}
                                        onMenuOpen={() => ConstantService.getConstantList('DRIVER_OUTCOME_SERVICE')}
                                        labelName='value'
                                        valueName='constantId'
                                    />
                                </div>
                            </div>
                        </KTCardBody>
                    </KTCard>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">
                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveService}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default ServiceAdd;